import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {ProductListComponent} from './product-list/product-list.component';


export const productRoutes: Routes = [
  {
    path: 'product',
    data: {
      'expectedRoles': ['Admin', 'Accountant', 'Accountant Admin']
    },
    children: [
      {
        path: 'list',
        component: ProductListComponent,
        data: {
          'expectedRoles': ['Admin', 'Accountant', 'Accountant Admin']
        },
      },
      {
        path: 'manage',
        component: ProductListComponent,
        data: {
          'expectedRoles': ['Admin', 'Accountant', 'Accountant Admin']
        },
      }
    ],
  }
];

@NgModule({
  imports: [RouterModule.forChild(productRoutes)],
  exports: [RouterModule]
})
export class ProductRoutingModule {
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/product/product-routing.module.ts